<template>
  <div id="my-profile" class="row reverse-mobile">
    <div class="col-12 col-md-3">
      <UserMenu></UserMenu>
    </div>
    <div class="col-12 col-md-9">
      <div class="row mb-4">
        <div class="d-flex flex-row align-items-center">
          <i class="material-icons material-icons-title mr-2">person</i>
          <h2 class="mt-2">My Profile</h2>
        </div>
      </div>

      <div class="row">
        <div class="card w-100">
          <div class="card-body">
            <div v-if="isLoadingUser" class="d-flex justify-content-center w-100">
              Loading...
            </div>
            <div v-else>
              <h3 class="card-title">{{user.username}}</h3>
              <div class="d-flex flex-column profile-stats my-3">
                <div class="d-flex align-items-center">
                  <i class="material-icons text-secondary">person</i>
                  <em>Username:</em>
                  <span class="element-label capitalize">
                    <em>{{ additionalInfo.username }}</em>
                  </span>
                </div>
                <div class="d-flex align-items-center">
                  <i class="material-icons text-secondary">lock_open</i>
                  <em>Last Login:</em>
                  <span class="element-label capitalize">
                    <em>{{ lastLogin }}</em>
                    <em>{{ additionalInfo.last_login }}</em>
                  </span>
                </div>
                <div class="d-flex align-items-center">
                  <i class="material-icons text-secondary">email</i>
                  <em>Email Address:</em>
                  <span class="element-label">
                    <em>{{ additionalInfo.email }}</em>
                  </span>
                </div>
                <div class="d-flex align-items-center">
                  <i class="material-icons text-secondary">business</i>
                  <em>Organisation:</em>
                  <span class="element-label">
                    <em>{{ user.organisation.name }}</em>
                  </span>
                </div>
                <div class="d-flex align-items-center">
                  <i class="material-icons text-secondary">web</i>
                  <em>Website:</em>
                  <a v-bind:href="user.organisation.website">
                    <span class="element-label">
                      <em>{{ user.organisation.website }}</em>
                    </span>
                  </a>
                </div>
                <div class="profile-privacy-container">
                  <div
                    @click="setPublic"
                    :class="{'active-btn': additionalInfo.is_public, 'inactive-btn': !additionalInfo.is_public}"
                  >
                    {{isLoading ? "..." : "Public"}}
                  </div>
                  <div
                    @click="setPrivate"
                    :class="{'active-btn': !additionalInfo.is_public, 'inactive-btn': additionalInfo.is_public}"
                  >
                    {{isLoading ? "..." : "Private"}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
import UserService from "../services/user.service";
import router from "../router";
import storage from "store";
export default {
  name: "MyDetailsChange",
  computed: {
    user() {
      return this.$store.getters.getUser;
    }
  },
  components: {
    UserMenu
  },

  data() {
    return {
      additionalInfo: {},
      isLoading: false,
      isLoadingUser: false,
    };
  },

  methods: {
    getAdditionalInfo() {
      this.componentLoading = true;
      this.isLoadingUser = true;

      UserService.getUserDetails(this.user.uuid_id)
        .then(data => {
          this.additionalInfo = data[0];
        })
        .catch(error => {
          if (error.message.includes("404")) {
            this.component404 = true;
          }
        })
        .finally(() => this.isLoadingUser = false);
    },
    setPrivate() {
      if (!this.additionalInfo.is_public || this.isLoading) return;

      this.isLoading = true;

      UserService.changeUserPrivacy(false)
        .then(() => {
          this.getAdditionalInfo();
          vm.$swal.fire("Success!", "Privacy changed!", "success");
        })
        .finally(() => this.isLoading = false);
    },
    setPublic() {
      if (this.additionalInfo.is_public || this.isLoading) return;

      this.isLoading = true;

      UserService.changeUserPrivacy(true)
        .then(() => {
          this.getAdditionalInfo();
          vm.$swal.fire("Success!", "Privacy changed!", "success");
        })
        .finally(() => this.isLoading = false);
    },
  },

  beforeMount() {
    this.getAdditionalInfo();
  }
};
</script>

<style scoped>
.profile-tags {
  padding: 10px;
  min-height: 80px;
  max-height: 80px;
  overflow-y: scroll;
  background: #f8f9fa;
  border-radius: 4px;
  border: 1px solid;
  border-color: #f8f9fa;
}

.profile-stats i {
  margin-right: 5px;
}

.profile-stats em {
  color: #6c757d;
  margin-right: 10px;
  font-size: 14px;
}
.profile-stats > div {
  margin-bottom: 10px;
}

.capitalize {
  text-transform: capitalize;
}

.news-pane {
  min-height: 200px;
}

.material-icons-title {
  font-size: 50px;
  color: #7d7d7d;
}

.profile-privacy-container {
  display: flex;
  height: 40px;
}
.profile-privacy-container > div {
  padding: 10px;
  cursor: pointer;
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.active-btn {
  background: #CB2E37;
  color: white;
}
.inactive-btn {
  background: white;
  color: #6c757d;
  border: 2px solid #6c757d;
}
</style>
